import styled from 'styled-components';
import { getNeutralColors, getMainColor } from '../theme';
import { BodyText2Css } from '../typography';

const StyledInput = styled.input.attrs(({ type }) => ({
  type: type || 'text'
}))`
  ${BodyText2Css}
  display: inline-block;
  background: ${getNeutralColors('white')};
  border: ${props => `1px solid ${getNeutralColors('grisMedioOscuro')(props)}`};
  box-sizing: border-box;
  border-radius: 8px;
  height: 48px;
  padding: 12px;

  :hover {
    border: ${props => `1px solid ${getNeutralColors('grisOscuro')(props)}`};
  }
  :focus {
    border: 1px solid ${getMainColor()};
  }
  ::placeholder {
    font-family: Hind;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #7c98a7;
  }
  :disabled {
    border: 0;
    background: ${getNeutralColors('grisClaro')};
    color: ${getNeutralColors('grisMedioOscuro')};
  }
`;

export default StyledInput;
